const products = [{
    "id": 1169605,
    "name": "D&O",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/d-o.svg"
}, {
    "id": 1169603,
    "name": "EPLI",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/epli.svg"
}, {
    "id": 1169615,
    "name": "Prof\/E&O Liability",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/prof-e-o-liability.svg"
}, {
    "id": 1169602,
    "name": "Cyber",
    "businessLine": ["Financial", "Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/cyber.svg"
}, {
    "id": 1169607,
    "name": "Fidelity\/Crime",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/fidelity-crime.svg"
}, {
    "id": 1169604,
    "name": "Fiduciary",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/fiduciary.svg"
}, {
    "id": 1169619,
    "name": "Kidnap & Ransom",
    "businessLine": ["Financial"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/kidnap-ransom.svg"
}, {
    "id": 1169606,
    "name": "Package",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/package.svg"
}, {
    "id": 1169612,
    "name": "Workers Comp",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/workers-comp.svg"
}, {
    "id": 1169614,
    "name": "Auto",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/auto.svg"
}, {
    "id": 1169618,
    "name": "Umbrella\/Excess",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/umbrella-excess.svg"
}, {
    "id": 1169608,
    "name": "Environmental",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/environmental.svg"
}, {
    "id": 1169613,
    "name": "General Liability",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/general-liability.svg"
}, {
    "id": 1169616,
    "name": "Property",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/property.svg"
}, {
    "id": 1169611,
    "name": "Equipment Breakdown",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/equipment-breakdown.svg"
}, {
    "id": 1169610,
    "name": "Inland Marine",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/inland-marine.svg"
}, {
    "id": 1169609,
    "name": "Ocean Cargo",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/ocean-cargo.svg"
}, {
    "id": 1169617,
    "name": "Multinational",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/multinational.svg"
}, {
    "id": 1206511,
    "name": "A&H",
    "businessLine": ["Property & Casualty"],
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/products\/d-o.svg"
}];

export default products;



// WEBPACK FOOTER //
// ./src/data/products.js